module.exports = __webpack_public_path__ + "assets/img/acknowledgement.263d1df6.jpg";